// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__J78q6","content":"styles_content__KWNTH"};